import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareUpRight, faBook } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState, useEffect, useMemo } from "react";
import { convertFileSize, getFileTypeIcon, isImageFile, removeFileExtension } from "../utils/file";
import folderIcon from "../assets/icons/folder.svg";
import service from "../utils/request";
import message from "../utils/message";
import { SpaceContext } from "../SpaceContext";
import Mark from "./Mark";
import { Favour, PersonalFavourite } from "./Mark";
import CheckInModal from "./common/CheckInModal";
import CheckOutModal from "./common/CheckOutModal";

export default function Itemcard({
    view, item, handleItemClick, handleOpen, spaceInfo, getFileList, setFileList,
    openFolder, setPath, setIsPropertiesModalVisible, setCurrentItem, selectedItems, setSelectedItems
}) {
    const { coolApps } = useContext(SpaceContext);

    const [favoUsers, setFavoUsers] = useState([]);
    const [isCheckedIn, setIsCheckedIn] = useState(item.is_checkin || false);
    const [isLibraryModalOpen, setIsLibraryModalOpen] = useState(false);

    const handleCheckInToggle = (e) => {
        e.stopPropagation();
        setIsLibraryModalOpen(true);
    };

    const handleLibraryStateChange = (nextCheckInState, nextPolicyId, nextName) => {
        setIsCheckedIn(nextCheckInState);
        item.is_checkin = nextCheckInState;
        item.policy_id = nextPolicyId;
        if (nextName) {
            item.item_name = nextName;
        }
        if (setSelectedItems && nextName) {
            setSelectedItems((prev) => {
                if (!prev || !prev[item.item_id]) return prev;
                return {
                    ...prev,
                    [item.item_id]: {
                        ...prev[item.item_id],
                        item_name: nextName,
                        is_checkin: nextCheckInState,
                        policy_id: nextPolicyId,
                    },
                };
            });
        }
        if (setFileList) {
            setFileList((prevFileList) =>
                prevFileList.map((it) =>
                    it.item_id === item.item_id
                        ? {
                            ...it,
                            ...(nextName ? { item_name: nextName } : {}),
                            is_checkin: nextCheckInState,
                            policy_id: nextPolicyId,
                        }
                        : it
                )
            );
        }
    };

    let userInfo = {};
    try {
        const stored = localStorage.getItem('user_info');
        if (stored && stored !== 'undefined') userInfo = JSON.parse(stored);
    } catch (e) { }

    useEffect(() => {
        setFavoUsers(item.liked_user_list);
        setIsCheckedIn(item.is_checkin || false);
    }, [item]);

    const stopPropagation = (event) => {
        event.stopPropagation();
    };

    async function handleEnterKeyUp(e) {
        if (e.keyCode === 13) {
            try {
                const itemInfo = await service.get('/filer/item/' + item.item_id)
                setCurrentItem({ ...itemInfo, permissions: item.permissions })
                setIsPropertiesModalVisible(true)
            } catch (error) {
                message("error", error);
            }
        }
    };

    async function handleFavoriteToggle(itemId) {
        try {
            const isCurrentlyFavorited = item.is_favour;
            const actionMessage = isCurrentlyFavorited ? "Removing from favorites..." : "Adding to favorites...";
            const successMessage = isCurrentlyFavorited ? "Removed from favorites successfully" : "Added to favorites successfully";

            message("loading", actionMessage);

            await service.post('/filer/rename', {
                item_id: itemId,
                is_favour: !isCurrentlyFavorited,
            });

            message("success", successMessage);

            // Only refresh the file list if we have a valid current_id
            if (spaceInfo?.current_id) {
                getFileList(spaceInfo.current_id);
            } else if (spaceInfo?.space_id) {
                getFileList(spaceInfo.space_id);
            }
        } catch (error) {
            message("error", error);
        }
    }

    async function handleMarkClick(id) {
        try {
            const itemInfo = await service.get('/filer/item/' + id)
            setCurrentItem({ ...itemInfo, permissions: item.permissions })
            setIsPropertiesModalVisible(true)
            setSelectedItems({
                [id]: {
                    is_folder: item.is_folder,
                    item_name: item.item_name,
                    permissions: item.permissions
                }
            });
        } catch (error) {
            message("error", error);
        }
    };


    const handleJumpBtnClick = async (item) => {
        await getFileList(item.folder_id === '' ? item.space_id : item.folder_id);
        const new_path = await service.get("/filer/path/" + item.item_id);

        setPath(new_path);
    }

    return (
        <section
            onKeyUp={handleEnterKeyUp}
            onClick={() => handleItemClick(item)}
            onDoubleClick={() => handleOpen(item)}
        >
            {view === 'list' ?
                <label className="relative flex items-center rounded-full cursor-pointer group">
                    <input
                        type="checkbox"
                        className=" outline-none group-hover:bg-zinc-200 before:content[''] peer relative h-14 w-full cursor-pointer appearance-none rounded border border-gray-200 bg-white transition-all checked:border-none checked:ring-2 checked:ring-[#ffa270] hover:bg-zinc-200 focus:bg-white"
                        checked={item.item_id in selectedItems}
                    />
                    <span
                        className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"></span>
                    <div
                        className="absolute flex flex-col px-4 pt-1 text-start"
                        onClick={stopPropagation}
                    >
                        <div
                            className="flex text-base font-semibold leading-none tracking-tight whitespace-nowrap text-neutral-900">
                            {!item.is_folder ?
                                (
                                    getFileTypeIcon(item.item_name, coolApps, null, item.item_type)
                                ) : (
                                    <img className="w-4 h-4 mr-2 " src={folderIcon} alt="" />
                                )
                            }
                            {item.item_name}
                            {(!item.is_folder && item.space_id !== spaceInfo.space_id && spaceInfo.space_id !== 'trash') &&
                                <button onClick={() => handleJumpBtnClick(item)}>
                                    <FontAwesomeIcon icon={faSquareUpRight} className="ml-2 w4 h4" />
                                </button>
                            }
                        </div>
                        <p className="py-1 text-xs text-neutral-600">
                            {!item.is_folder && <span className="mr-2">{convertFileSize(item.item_size)}</span>}
                            {(item.created_by !== '') && <span className="mr-2">owner {item.created_by}</span>}
                            <span className="mr-2">created on {item.created_time}</span>
                            <span>Last modified on {item.modified_time}</span>
                        </p>
                    </div>
                    <div className=" absolute right-[-6px] top-[-6px] w-4 h-4">
                        {
                            favoUsers.length > 0 &&
                            <Favour
                                favoUsers={favoUsers}
                                id={item.item_id}
                                handleHeartClick={handleMarkClick}
                            />
                        }
                    </div>

                    <Mark
                        value={item.item_mark}
                        id={item.item_id}
                        handleItemClick={handleMarkClick}
                        publicMark={item.public_mark || 0}
                        isFavourite={item.is_favour || false}
                    />

                    {!item.is_folder && (
                        <button
                            onClick={handleCheckInToggle}
                            className="absolute w-4 h-4 flex items-center justify-center text-zinc-400 hover:text-[#FF8C39] transition-colors duration-200"
                            style={{ right: "38px", top: "16px" }}
                            title={isCheckedIn ? "Remove from Library" : "Check in to Library"}
                        >
                            <FontAwesomeIcon icon={faBook} className={`w-3.5 h-3.5 ${isCheckedIn ? 'text-[#FF8C39]' : 'text-zinc-400'}`} />
                        </button>
                    )}

                    <div className=" absolute right-[-6px] bottom-[-6px] w-4 h-4">
                        {
                            item.is_favour &&
                            <PersonalFavourite
                                isFavourite={item.is_favour}
                                onClick={() => handleFavoriteToggle(item.item_id)}
                            />
                        }
                    </div>
                </label> :
                <div tabIndex="0" title={item.item_name} onKeyUp={handleEnterKeyUp} className={`outline-none relative p-2 w-28 h-28 border-2 rounded hover:bg-zinc-300  
                transition-all cursor-pointer flex items-center flex-col ${item.item_id in selectedItems ? 'border-[#ffa270]' : 'border-gray-200'}`}>
                    {!item.is_folder ?
                        (
                            isImageFile(item.item_name) ?
                                <img loading="lazy" src={`/filer/open/${item.item_id}`} className=" h-14"
                                    alt="" /> : getFileTypeIcon(item.item_name, coolApps, "w-20 h-14", item.item_type)
                        ) : (
                            <img className="w-20  h-14" src={folderIcon} alt="" />
                        )
                    }
                    <div
                        className={`transition-all w-full border-t-2 mt-1 ${item.item_id in selectedItems ? 'border-[#ffa270]' : 'border-gray-200'}`}></div>
                    <div className="w-full mt-1 text-sm font-semibold leading-none tracking-tight  text-neutral-900"><p
                        className="truncate">{item.item_name}</p></div>
                    {(item.created_by !== '') && <span className="text-xs  text-neutral-600">{item.created_by}</span>}
                    {(!item.is_folder && item.space_id !== spaceInfo.space_id && spaceInfo.space_id !== 'trash') &&
                        <button className="absolute  top-1 right-1" onClick={() => handleJumpBtnClick(item)}>
                            <FontAwesomeIcon icon={faSquareUpRight} className="ml-2 w4 h4" />
                        </button>
                    }

                    <Mark
                        value={item.item_mark}
                        id={item.item_id}
                        handleItemClick={handleMarkClick}
                        publicMark={item.public_mark || 0}
                        isFavourite={item.is_favour || false}
                    />

                    {!item.is_folder && (
                        <button
                            onClick={handleCheckInToggle}
                            className="absolute w-4 h-4 flex items-center justify-center text-zinc-400 hover:text-[#FF8C39] transition-colors duration-200"
                            style={{ right: "16px", top: "38px" }}
                            title={isCheckedIn ? "Remove from Library" : "Check in to Library"}
                        >
                            <FontAwesomeIcon icon={faBook} className={`w-3.5 h-3.5 ${isCheckedIn ? 'text-[#FF8C39]' : 'text-zinc-400'}`} />
                        </button>
                    )}

                    <div className=" absolute right-[-6px] bottom-[-6px] w-4 h-4">
                        {
                            item.is_favour &&
                            <PersonalFavourite
                                isFavourite={item.is_favour}
                                onClick={() => handleFavoriteToggle(item.item_id)}
                            />
                        }
                    </div>

                </div>
            }

            {isLibraryModalOpen && (
                isCheckedIn ? (
                    <CheckOutModal
                        isOpen={isLibraryModalOpen}
                        onClose={() => setIsLibraryModalOpen(false)}
                        onStateChange={handleLibraryStateChange}
                        item={item}
                        policyId={item.policy_id}
                        setFileList={setFileList}
                    />
                ) : (
                    <CheckInModal
                        isOpen={isLibraryModalOpen}
                        onClose={() => setIsLibraryModalOpen(false)}
                        item={item}
                        setFileList={setFileList}
                        onSuccess={(policyId, updatedNames) => {
                            const newName = updatedNames?.[item.item_id];
                            handleLibraryStateChange(true, policyId, newName);
                        }}
                    />
                )
            )}
        </section>
    );
}

